import { FC, ReactElement, memo, useMemo } from 'react';
import { IProductInsideCombo } from 'src/types/combo';
import { getTranslate } from 'src/utils/formatter';
import '../Description/style.scss';
import { localeStore } from 'src/mobx/localesStore';

export const Allergens: FC<IProductInsideCombo> = memo((item: IProductInsideCombo): ReactElement | null => {
  const itemAllergensText = useMemo(() => {
    if (!item?.allergens.length) return null;

    return `${localeStore.t('consumer_item_allergens_declaration_txt')}: ${item?.allergens
      .map((allergen) => getTranslate(allergen.description))
      .join(', ')}. ${localeStore.t('consumer_item_allergens_declaration_afterlist_txt')}`;
  }, [item?.allergens]);

  if (!itemAllergensText) return null;

  return (
    <p className="product-meal-combo-group-mobile-item-modal__description color-dark pxmb-4">{itemAllergensText}</p>
  );
});
